module.exports = __webpack_public_path__ + "static/img/jx-wjrpd.d81329b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/jx-wjrpd.png
// module id = UD4s
// module chunks = 0